import React, { useContext } from "react";

const defaultValue = {};
export const ArchiveContext = React.createContext(defaultValue);

export const useArchiveContext = () => useContext(ArchiveContext);
